"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextCut = void 0;
var react_1 = __importDefault(require("react"));
/**
 * 截取字符串长度
 * @param props
 * @returns
 */
function TextCut(props) {
    var _a, _b;
    var tip = (_a = props.tip) !== null && _a !== void 0 ? _a : true;
    return react_1.default.createElement("span", { className: "text_cut", title: tip ? props.text : '', style: { maxWidth: props.width } }, (_b = props.children) !== null && _b !== void 0 ? _b : props.text);
}
exports.TextCut = TextCut;
